import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useSaveCustomSectionDefinition = function () {
    return useApiCall(function (signal, payload) { return api.customSections.apiCustomFieldSectionPost(payload, { signal: signal }); }, null, true, [], { success: 'Custom section saved.' });
};
